import React from "react";
import { useServerDown } from "../../services/ServerDownProvider";
import ServerDownDialog from "./ServerDownDialog";

const ServerDownHandler = () => {
    const { isServerDown, hideServerDownDialog } = useServerDown();

    return (
        <ServerDownDialog
            open={isServerDown}
            onClose={hideServerDownDialog}
        />
    );
};

export default ServerDownHandler;